import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import createMiddleware from './middleware/client-middleware';
import { deserialize } from './serializer';

export default function createStore({
  reducer,
  client,
  data /*, history = browserHistory*/
}) {
  // const reduxRouterMiddleware = syncHistory(history);
  const middleware = [createMiddleware(client) /*, reduxRouterMiddleware*/];

  let finalCreateStore;
  if (__DEV__ && __DEVTOOLS__) {
    const { persistState } = require('redux-devtools');
    const DevTools = require('./devtools').default;
    finalCreateStore = compose(
      applyMiddleware(...middleware),
      DevTools.instrument(),
      persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
    )(_createStore);
  } else {
    finalCreateStore = applyMiddleware(...middleware)(_createStore);
  }

  const store = finalCreateStore(reducer, deserialize(data));
  // syncHistoryWithStore(history, store);
  // reduxRouterMiddleware.listenForReplays(store);

  if (__DEV__ && module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  return store;
}
